const fixFloat = (number, digits = 4) => {
  return typeof number === 'number' ? parseFloat(Number(number).toFixed(digits)) : number;
};

export default fixFloat;
